import { parseAnswer } from "@cosmosai/api-client";
import type { z } from "zod";

/** Awaits a cosmos API call and parses its answer with a view (an UnexpectedAnswerError naming the endpoint otherwise). */
export async function read<S extends z.ZodType>(
  schema: S,
  endpoint: string,
  call: Promise<{ data?: unknown }>,
): Promise<z.infer<S>> {
  const { data } = await call;
  return parseAnswer(schema, endpoint, data);
}
